export enum WicketAdminUserActivityType {
  eventWatch = 'event.watch',
  signIn = 'sign.in',
}

export interface WicketAdminUserActivity {
  activity_type: WicketAdminUserActivityType;
  fan_id: string;
  created_at: string;
  activity_properties: WicketAdminUserEventWatchAcivityData | WicketAdminActivityData;
}

export interface FlattenedWicketAdminUserActivity {
  activity_type: WicketAdminUserActivityType;
  fan_id: string;
  createdAt: string;
  [key: string]: any;
}

export interface WicketAdminUserActivityDataBase {
  browserInfo: string;
  osInfo: string;
  deviceModel: string;
  deviceBrand: string;
  deviceFamily: string;
  clientIp: string;
  userAgent: string;
  eventId: string;
  eventFormatAvailability: 'free' | 'subscription';
}

export interface WicketAdminUserEventWatchAcivityData
  extends WicketAdminUserActivityDataBase {
  eventTitle: string;
  eventType: string;
  watchTime: string;
  sessionId: string;
}

export interface WicketAdminActivityData extends WicketAdminUserActivityDataBase {
  authFlow: string;
}
